<template>
    <div >
        <app-sub-title text="Reporte de rondas" />
        <b-row>
            <b-col>
                <app-rounds-review-filters @filters="onFilter" @clearFilters="onClearFilter"/>      
            </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
            <b-col cols="4">  
                <b-btn
                    block
                    @click="reportRounds"
                    title="Descargar"
                    variant="primary"
                >
                    <i class="fa fa-download" aria-hidden="true"></i> Descargar reporte de rondas
                </b-btn>
            </b-col>
        </b-row>
        <div class="alert alert-info" v-if="!data || !data.length">
            <h4>No hay información</h4>
        </div>
        <div
            class="rounds-review-data d-flex flex-column align-items-center"
            v-if="!!data && !!data.length"
        >
            <app-rounds-review-list
            style="overflow-y:scroll; height: 70vh;" 
            :data="data"
            :on-change-page="onChangePage" />
        </div>
    </div>
</template>
<script>
import RoundsReviewList from '../../Company/Rounds/RoundsReviewList'
import RoundsReviewFilters from '../../Company/Rounds/RoundsReviewFilters'
export default {
    components: {
        appRoundsReviewList: RoundsReviewList,
        appRoundsReviewFilters: RoundsReviewFilters,
    },
    data() {
        return {
            filters: '',
            data: '',
            page: 1,
        }
    },
    methods: {
        onClearFilter(){
            this.data = []
            this.filters = ''
        },
        onFilter(filters){
            this.filters = filters
            this.loadRounds()
        },
        async loadRounds() {
            try {
                const params = {...this.filters, page: this.page};
                const {data} = await repo.get('rounds/review',params);
                this.data = data;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        reportRounds() {
            if(this.filters == ''){
                return toastr.info('Porfavor filtre la información previamente')
            }
            const filters = { ...this.filters }
            const params = []
            _.forIn(filters, (value, key) => {
                if (!value) return
                params.push(`${key}=${value}`)
            })

            const queryString = params.join('&')
            window.open(
                `exports/rounds-review/export-excel?` + queryString,
                '_blank'
            )
        },
        onChangePage(page) {
            this.page = page;
            this.loadRounds();
        }
    },
    mounted() {
    },
}
</script>
